/*jshint esversion: 6 */
// import store from '@/store/index';
import UltraRoute from '@/router/components/UltraRoute.js';
import WorkPackageEditorModule from '@/router/modules/WorkPackageEditor.module.js';
import WorkPackageImageZoom from '@/router/modules/WorkPackageImageZoom.module.js';
import WorkPackageInfoBox from '@/router/modules/WorkPackageInfoBox.module.js';

function Template(payload) {
  let route = UltraRoute({
    name: `${payload.location}WaggonEditor`,
    path: ':waggon_id',
    folder: 'WorkBenchRework',
    file: 'WorkBenchWaggonEditor',
    auth:true,
    props: (route) => {
      return {
        read_only: ['custom', 'company'].includes(route.params.template_type)?false:true,
        create: route.params.waggon_id === 'create'?true:false,
        location: payload.location,
        template_type: route.params.template_type,
        waggon_id: route.params.waggon_id
      };
    },
    children: [
      UltraRoute({
        name: `${payload.location}WaggonWorkPackage`,
        path: 'workpackages/:workpackage_id',
        folder: 'WorkBenchRework',
        file: 'WorkBenchWaggonWorkPackage',
        auth:true,
        props: (route) => {
          return {
            read_only: ['custom', 'company'].includes(route.params.template_type)?false:true,
            create: route.params.waggon_id === 'create'?true:false,
            location: payload.location,
            waggon_id: route.params.waggon_id,
            work_package_id: route.params.workpackage_id
          };
        },
        children:[
          WorkPackageEditorModule({
            path: 'edit',
            location: `${payload.location}Waggon`,
            read_only: false,
            nav_back: `${payload.location}WaggonWorkPackage`,
          }),
          WorkPackageImageZoom(Object.assign(JSON.parse(JSON.stringify(payload)), {
            location: `${payload.location}Waggon`,
            close: `${payload.location}WaggonWorkPackage`
          }))
        ]
      }),
      UltraRoute({
        name: `${payload.location}WaggonWorkPackageAdd`,
        path: 'addworkpackage',
        folder: 'WorkBenchRework',
        file: 'WorkBenchWaggonWorkPackageAdd',
        props: () => {
          return {
            location: `${payload.location}Waggon`
          }
        },
        auth:true,
        children: [
          WorkPackageInfoBox(Object.assign(JSON.parse(JSON.stringify(payload)), {
            location: `${payload.location}Waggon`
          })),
          WorkPackageEditorModule({
            path: ':workpackage_id',
            location: `${payload.location}WaggonWorkPackageAdd`,
            read_only: false,
            nav_back: `${payload.location}WaggonWorkPackageAdd`,
          }),
        ]
      })

    ]
  });
  return route;
}
export default Template;
